import { schema } from 'normalizr';

export const jobListing = new schema.Entity('jobListings');

export const contactSource = new schema.Entity('contactSources');

export const application = new schema.Entity('applications');
